export const LIST_SECURE_CREDIT_INSTALMENTS_PERCENTAGES = 'LIST_SECURE_CREDIT_INSTALMENTS_PERCENTAGES';
export const SAVE_SECURE_CREDIT_INSTALMENTS_PERCENTAGES = 'SAVE_SECURE_CREDIT_INSTALMENTS_PERCENTAGES';
